:host {
  display: block;
}

a {
  background-color: #25D366;
  color: white;
  text-decoration: none;
  padding: 10px 10px;
  font-family: inherit;
  display: flex;
  align-items: center;
  column-gap: 4px;
  min-width: min-content;
  max-width: var(--custom-max-width, max-content);
  justify-content: center;
  cursor: pointer;
}